/**
 * @generated SignedSource<<55c84dbb1a99f64343951d69b825b949>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GraphQLJobRunStatus = "COMPLETED" | "ERRORED" | "IN_PROGRESS" | "PENDING" | "STOPPED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type JobRunOutput_jobRun$data = {
  readonly id: any;
  readonly outputJson: any | null | undefined;
  readonly sources: ReadonlyArray<{
    readonly artifactId: string | null | undefined;
    readonly displayText: string;
    readonly link: string | null | undefined;
    readonly query: any | null | undefined;
    readonly sourceId: number | null | undefined;
    readonly toolId: string | null | undefined;
    readonly type: string | null | undefined;
  }>;
  readonly status: GraphQLJobRunStatus;
  readonly " $fragmentSpreads": FragmentRefs<"AlertResponderJobRun_jobRun">;
  readonly " $fragmentType": "JobRunOutput_jobRun";
};
export type JobRunOutput_jobRun$key = {
  readonly " $data"?: JobRunOutput_jobRun$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobRunOutput_jobRun">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobRunOutput_jobRun",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "outputJson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLIntegrationQuerySource",
      "kind": "LinkedField",
      "name": "sources",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "toolId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "query",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "link",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "artifactId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayText",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AlertResponderJobRun_jobRun"
    }
  ],
  "type": "GraphQLJobRun",
  "abstractKey": null
};

(node as any).hash = "2339a9fe0a1b7fe0901e07860b53ec23";

export default node;
